import React, { useState } from "react"
import { Link } from "gatsby"
import scrollTo from "gatsby-plugin-smoothscroll"
export interface FunctionCortexBlockProps {}

const personDetection = require("../images/icons-function/person-detection.svg") as string
const personTracking = require("../images/icons-function/person-tracking.svg") as string
const faceDetection = require("../images/icons-function/face-detection.svg") as string
const attentionDetection = require("../images/icons-function/attention-detection.svg") as string
const emotionPrediction = require("../images/icons-function/mask-detection.svg") as string
const maskDetection = require("../images/icons-function/emotion-prediction.svg") as string
const handGesture = require("../images/icons-function/hand-gesture-recognition.svg") as string
const gazeEstimation = require("../images/icons-function/gaze-estimation.svg") as string

const FunctionCortexBlock: React.SFC<FunctionCortexBlockProps> = () => {
  const [dataFunction, setDatFunction] = useState([
    {
      title: "Person Detection",
      icon: personDetection,
      section: "人の検出",
      description: "画像内の人とその位置を検出",
      animation: "slide-up",
      target: "#persondetection",
    },
    {
      title: "Person Tracking",
      icon: personTracking,
      section: "同一人物の追跡",
      description: "同一人物を複数フレームに渡って追跡、複数人にも対応",
      animation: "slide-up",
      target: "#persontracking",
    },
    {
      title: "Face Detection",
      icon: faceDetection,
      section: "顔の検出",
      description: "画像内の人の顔と位置を検出",
      animation: "slide-up",
      target: "#facedetection",
    },
    {
      title: "Attention Detection",
      icon: attentionDetection,
      section: "視線の検出",
      description: "人の視線を検出し、注視しているかどうかを認識",
      animation: "slide-up",
      target: "#attentiondetection",
    },
    {
      title: "Emotion Prediction",
      icon: maskDetection,
      section: "感情の推定",
      description: "検出した人の表情から感情を推定",
      animation: "slide-up",
      target: "#emotionprediction",
    },
    {
      title: "Mask Detection",
      icon: emotionPrediction,
      section: "マスク装着有無の検出",
      description: "マスクを装着しているか検出",
      animation: "slide-up",
      target: "#maskdetection",
    },
    {
      title: "Gaze Estimation",
      icon: gazeEstimation,
      section: "視線の方向の検出",
      description: "人の視線を検出し、その視線の方向を検出",
      animation: "slide-up",
      target: "",
    },
  ])
  return (
    <div className="container-full block-function">
      <h3 className="u-text-center subtitle-section">機能</h3>
      <div className="container block-function__list-section">
        <ul className="block-function__list">
          <li>・画像上の人間の情報を細かく検出・識別 </li>
          <li>
            ・軽量のスタンドアローン型AIの為、認識スピードが速くセキュリティも高い
          </li>
          <li> ・安価のシステム(Jetson Nano™+ 市販のカメラ)で稼働 </li>
        </ul>
      </div>
      <div className="container block-function__card-section">
        <div className="row">
          {dataFunction.map((item, i) => (
            <div
              key={i}
              className="col-lg-4 col-md-6 col-sm-12 u-padding-20 u-padding-left-2
            u-padding-right-2 card-main"
            >
              {item.target === "" ? (
                <div className="card-content card-content-no-link">
                  <h4 className="u-text-center">{item.title}</h4>
                  <img src={item.icon} alt="" />
                  <h5 className="u-text-center u-text-bold">{item.section}</h5>
                  <p className="u-text-center">{item.description}</p>
                </div>
              ) : (
                <div
                  className="card-content"
                  onClick={() => scrollTo(item.target)}
                >
                  <h4 className="u-text-center">{item.title}</h4>
                  <img src={item.icon} alt="" />
                  <h5 className="u-text-center u-text-bold">{item.section}</h5>
                  <p className="u-text-center">{item.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FunctionCortexBlock
